module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-finish",
    style: ({
      height: _vm.isPhone ? 'calc(100vh - 120px)' : '570px'
    })
  }, [(_vm.isPhone) ? _c('div', {
    staticClass: "wrap2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "actionsWrap"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "danger",
    on: {
      "click": _vm.handleClear2
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('button', {
    staticClass: "warning",
    on: {
      "click": _vm.handleUndo2
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('button', {
    staticClass: "success",
    on: {
      "click": _vm.handlePreview2
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('canvas', {
    ref: "canvas2",
    staticClass: "canvas",
    staticStyle: {
      "flex": "1"
    }
  })]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "wrap1",
    staticStyle: {
      "margin-top": "0px",
      "height": "550px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('canvas', {
    ref: "canvas1",
    staticClass: "canvas1",
    staticStyle: {
      "width": "800px",
      "height": "400px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "danger",
    on: {
      "click": _vm.handleClear1
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('button', {
    staticClass: "warning",
    on: {
      "click": _vm.handleUndo1
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('button', {
    staticClass: "success",
    on: {
      "click": _vm.handlePreview1
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('popup', {
    ref: "popupShows"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding": "10px",
      "text-align": "center",
      "transform": "translateY(-50%) rotate(90deg)",
      "width": "600px",
      "height": "20px",
      "position": "absolute",
      "top": "50%"
    }
  }, [_vm._v("\n      请学员签署"), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("本人姓名")]), _vm._v("授权"), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("支付")]), _vm._v(" 扫码，支付服务费\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "26px",
      "padding": "20px",
      "text-align": "center"
    }
  }, [_vm._v("\n      请学员签署"), _c('span', {
    staticStyle: {
      "font-size": "36px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("本人姓名")]), _vm._v("授权"), _c('span', {
    staticStyle: {
      "font-size": "36px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("支付")]), _vm._v(" 扫码，支付服务费\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-814cf73a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/signer_jj.vue
// module id = 485
// module chunks = 1